export default __webpack_public_path__ + "static/338-18a2c133ab0a2d0b3664eaa9b00c8193.gif";